import React from "react"

import { Container, Row, Col } from "reactstrap"
import Link from "../components/link"
import Button from "../components/btn"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { FaGithub, FaDog, FaHome, FaBone, FaPaw } from "react-icons/fa"
import Form from "../components/form"
import Slider from "../components/slider"
import Box from "../components/box"
import Hr from "../components/hr"
import Benefits from "../components/benefits"
import styled from "styled-components"
import HomeFeatures from "../components/homeFeatures"
import Testimonials from "../components/testimonials"

let StyledBackground = styled.div`
  background: linear-gradient(to bottom, #f9fbfd 0, #fff 100%);
`

let Service = ({ title, Icon = FaHome }) => (
  <Col xs={12} md={4} className="mb-3">
    <Link to="/">
      <Box>
        <Icon size={30} />
        <h4 className="mt-3">{title}</h4>
      </Box>
    </Link>
  </Col>
)

let Index = () => (
  <Layout>
    <SEO title="Home" />
    <Slider />
    <Container className="pt-4">
      <div className="text-center">
        <h4>What better way to learn React then build with React</h4>
        <p className="text-muted">
          Built with Gatsby, Bootstrap, Stlyed Components and GraphQl
        </p>
      </div>
    </Container>
    <Container className="py-5">
      <h2 className="text-center mb-4">What is this thing?</h2>
      <Row>
        <Service title="Find your breed" Icon={FaDog} />
        <Service title="Doggo Stats" Icon={FaBone} />
        <Service title="Fun facts " Icon={FaPaw} />
      </Row>
    </Container>
    <StyledBackground>
      <Benefits />
    </StyledBackground>
    <HomeFeatures />
    <Testimonials />
  </Layout>
)

export default Index
